module.exports = __webpack_public_path__ + "hero.cc2bb494292a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/marketing/faq/hero.jpg
// module id = ./src/styles/marketing/faq/hero.jpg
// module chunks = 21